const getMilisecondsByIntervalType = (type) => {
    const milisecondValues = {
        minute: 60000,
        hour: 3600000,
        day: 86400000,
    };

    return milisecondValues[type];
};

const parseJson = (json, defaultData) => {
    let data = defaultData;

    try {
        data = JSON.parse(json);
    } catch (error) {}

    return data;
};

export const safeLocalStorage = {
    /**
     * @param {string} key
     * @return {string|null}
     */
    getItem(key) {
        try {
            return localStorage.getItem(key);
        } catch (error) {
            return null;
        }
    },

    /**
     * @param {string} key
     * @param {string} value
     */
    setItem(key, value) {
        try {
            localStorage.setItem(key, value);
        } catch (error) {
            // skip
        }
    },

    /**
     * @param {string} key
     */
    removeItem(key) {
        try {
            localStorage.removeItem(key);
        } catch (error) {
            // skip
        }
    },
};
export const checkFrequencyCap = (frequencyParams, storageKey) => {
    if (!frequencyParams || !window.localStorage || !window.JSON) {
        return true;
    }

    let data = safeLocalStorage.getItem(storageKey);

    if (!data) {
        return true;
    }

    data = parseJson(data, false);

    if (!data || !Array.isArray(data)) {
        return true;
    }

    if (data.length < frequencyParams.cap) {
        return true;
    }

    const capInterval = getMilisecondsByIntervalType(frequencyParams.intervalType) * frequencyParams.intervalAmount;
    const time = Date.now() - capInterval;

    for (let i = 0; i < frequencyParams.cap; i++) {
        if (data[i] < time) {
            return true;
        }
    }

    return false;
};

/**
 * Store impression for daily frequency cap usage
 * @param {{cap: number, intervalAmount: number, intervalType: string}} frequencyParams
 * @param {string} storageKey
 */

export const storeFrequencyImpression = (frequencyParams, storageKey) => {
    if (!frequencyParams || !window.localStorage || !window.JSON) {
        return;
    }

    let data = safeLocalStorage.getItem(storageKey);

    if (data) {
        data = parseJson(data, false);
    }

    const now = Date.now();

    if (!data || !Array.isArray(data)) {
        data = [];
    } else {
        const intervalMs = getMilisecondsByIntervalType(frequencyParams.intervalType) * frequencyParams.intervalAmount;
        const previousValue = now - intervalMs;

        data = data.filter((timestamp) => timestamp > previousValue);
    }

    data.unshift(now);

    if (data.length > frequencyParams.cap) {
        data = data.slice(0, frequencyParams.cap);
    }

    safeLocalStorage.setItem(storageKey, JSON.stringify(data));
};
